module.exports = __webpack_public_path__ + "img/business_messages.fa73fc19.svg";